import * as React from 'react';

function QRcode(props) {

  return (
    <img src={props.uri}></img>
  );
}

export default QRcode;
